<div class="etl-tasks-editor-container">
    <div class="header-container">
        <label>{{ title }}</label>
        <smart-icon name="close" (click)="onSlideSheetClose()" class="light"></smart-icon>
    </div>
    <div class="input-container">
        <div class="tam-form-field" [ngClass]="{'has-error':name.invalid}">
            <label class="required">ETL Task Name</label>
            <input [(ngModel)]="etlTask.name" class="tam-input tam-textbox" type="text" value="etlTask.name"
                [formControl]="name" [readonly]="isEdit" [class.disabled]="isEdit" />
            <div class="tam-form-help" *ngIf="name.invalid && name.errors['required']">
                {{'general.required_error_message' | stringLiterals}}
            </div>
            <div class="tam-form-help" *ngIf="name.invalid && name.errors['maxlength']">
                {{'general.name_exceed_maximum' | stringLiterals: '128'}}
            </div>
            <div class="tam-form-help" *ngIf="name.invalid && name.errors['nameDuplicated'] && !isEdit">
                {{'general.name_already_exist' | stringLiterals}}
            </div>
        </div>
        <div class="tam-form-field">
            <label>ETL Operation Type</label>
            <kendo-dropdownlist [popupSettings]="{appendTo: 'component'}" style="width: 100%"
                [data]="etlOperationTypeItems" [(ngModel)]="selectedETLOperationType"
                (selectionChange)="onChangeETLOperationType($event)" [disabled]="isEdit">
            </kendo-dropdownlist>
        </div>
        <div class="properties" *ngIf="etlTask.tssETLTaskPropertyList?.length > 0">
            <label class="title">Properties for Task: {{etlTask.name}}</label>
            <div class="content">
                <div *ngFor="let item of etlTask.tssETLTaskPropertyList">
                    <label>{{item.propertyName}}</label>
                    <input [(ngModel)]="item.propertyValue" class="tam-input tam-textbox" type="text"
                        value="item.propertyValue">
                </div>
            </div>
        </div>
        <div class="button-container">
            <button tam-button [tamType]="'primary'" [tamSize]="'normal'" class="button" (click)="onSubmitClick()">
                {{'general.submit' | stringLiterals}}
            </button>
            <button tam-button [tamType]="'tertiary'" [tamSize]="'normal'" class="button" (click)="onSlideSheetClose()">
                {{'general.cancel' | stringLiterals}}
            </button>
        </div>
    </div>